export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "oauth授权",
    layout: null,
    login: false
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {

}

export default {
    en: {

    },
    zh: {

    }
}
